import { render, staticRenderFns } from "./PanelEditMenu.vue?vue&type=template&id=f25727f0&scoped=true&"
import script from "./PanelEditMenu.vue?vue&type=script&lang=js&"
export * from "./PanelEditMenu.vue?vue&type=script&lang=js&"
import style0 from "./PanelEditMenu.vue?vue&type=style&index=0&id=f25727f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25727f0",
  null
  
)

export default component.exports